// import { createSelector } from 'reselect';

// common
export const getIsGetting = state => state.getIn(['resetPassword', 'isGetting']);
export const getIsPutting = state => state.getIn(['resetPassword', 'isPutting']);
export const getErrMsg = state => state.getIn(['resetPassword', 'errMsg']);